import axios from "axios";

export const GET_INVOICES_BY_CUSTOMER_URL = "/receipts/getInvoicesByCustomer?customerID=";

export function getInvoicesByCustomer(customerID) {
  return axios.get(`${GET_INVOICES_BY_CUSTOMER_URL}${customerID}`, customerID);
}

